import { Component, Input, OnInit } from '@angular/core';
import { CCaller } from '@models/imported/SagaSchema/CCaller';
import { SagaSettingsService } from '@services/settings';

@Component({
  selector: 'app-callcard-ccaller-card',
  templateUrl: './callcard-ccaller-card.component.html',
  styleUrls: ['./callcard-ccaller-card.component.scss']
})
export class CallcardCcallerCardComponent implements OnInit {
  @Input() enableInteraction: boolean = true;
  @Input() caller: CCaller;

  showIsFirstCaller: boolean = true;

  constructor(private sagaSettings: SagaSettingsService) {}

  ngOnInit(): void {
    this.showIsFirstCaller = this.sagaSettings.getValue('SagaMobileWebClient.ShowIsFirstCaller');
  }

  icon(collapsed: boolean) {
    return collapsed ? 'add-outline' : 'remove-outline';
  }

  /**
   * Call a phone number via the native
   */
  async call(phoneNumber: string) {
    if (this.enableInteraction && phoneNumber) {
      window.open(`tel: ${phoneNumber}`);
    }
  }
}
